import React from "react";
import backgroundImage from '../assets/img/13.jpg';

const Hero = () => {
  const handleDownload = () => {
    // Alternatif olarak analitik izleme veya başka işlemler eklenebilir
    console.log("APK indirme başlatıldı");
  };

  return (
    <>
      <div
        className="content_2_index_first"
        style={{ backgroundImage: `url(${backgroundImage})` }}
        >
        <div>
          <div className="inner">
            <h3>aufantasy</h3>
            <h2>Unleash the Cricket Experience!</h2>
            <div className="link">
              <a
                href="https://hitkingxcr.com/wp-content/hitkingxcr.com.apk"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleDownload}
              >
                <span>Download APK</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;